import { useAalKpisQuery } from "../aalV2";

export type WithdrawalsAALKPIsFilters = {
  start_date: string;
  end_date: string;
};

export type WithdrawalsAALKPIsResponse = {
  total_withdrawal_amount_reviewed?: string | number;
  total_withdrawal_amount_reviewed_pct_change?: number;
  withdrawals_reviewed_count?: number;
  withdrawals_reviewed_count_pct_change?: number;
  withdrawals_approved_count?: number;
  withdrawals_approved_count_pct_change?: number;
  withdrawals_declined_count?: number;
  withdrawals_declined_count_pct_change?: number;
  avg_request_to_decision_seconds?: number;
  avg_request_to_decision_pct_change?: number;
  avg_review_start_to_decision_seconds?: number;
  avg_review_start_to_decision_pct_change?: number;
  comparison_start_date?: string;
  comparison_end_date?: string;
} | null;

export const useGetAALWithdrawalsKPIs = (
  filters: WithdrawalsAALKPIsFilters,
) => {
  const { start_date, end_date } = filters;

  return useAalKpisQuery<WithdrawalsAALKPIsResponse>("withdrawals", {
    start_date,
    end_date,
  });
};
